import _ from 'lodash';
import { getRequest } from '../../Common/network-call';
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const FETCH_FAQS = 'FETCH_FAQS';
export const SELECTED_FAQ = 'SELECTED_FAQ';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';

export const fetchFAQs = (session, callback) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.docFAQs}?filter=${fetchFilter}`;
  const fetchCateUrl = `${fetchUrl}&fields=${FIELDS.docFAQs.minInfo}&group=${FIELDS.docFAQs.group}`;
  const fetchListUrl = `${fetchUrl}&fields=${FIELDS.docFAQs.mediumInfo}&include_count=true`;

  return dispatch => {
    getRequest(
      fetchCateUrl,
      session,
      dispatch,
      categoryRes => {
        let categoryDataArr = categoryRes?.resource;
        let categoryCount = categoryRes?.resource?.length;

        getRequest(
          fetchListUrl,
          session,
          dispatch,
          listRes => {
            let listDataArr = listRes?.resource;
            let listCount = listRes?.meta?.count;

            let workingArr = categoryDataArr;
            _.map(workingArr, cate => {
              cate.data = _.filter(
                listDataArr,
                item => item.category == cate.category
              );

              cate.data = _.orderBy(cate.data, 'displayorder', 'asc');
            });
            workingArr = _.orderBy(workingArr, 'displaycategoryorder', 'asc');

            dispatch({
              type: FETCH_FAQS,
              payload: {
                count: listCount,
                category: { data: categoryDataArr, count: categoryCount },
                list: { data: listDataArr, count: listCount },
                data: workingArr
              }
            });
            callback({
              success: 2,
              count: listCount,
              category: { data: categoryDataArr, count: categoryCount },
              list: { data: listDataArr, count: listCount },
              data: workingArr
            });
          },
          listError => {
            callback({
              success: 1,
              message: listError,
              type: 'list',
              cateData: { data: categoryDataArr, count: categoryCount }
            });
          }
        );
      },
      categoryError => {
        callback({ success: 0, message: categoryError, type: 'category' });
      }
    );
  };
};

export const clearFAQList = () => {
  return dispatch => {
    dispatch({ type: FETCH_FAQS, payload: {} });
  };
};

export const selectFAQ = value => {
  return dispatch => {
    dispatch({ type: SELECTED_FAQ, payload: {} });
    dispatch({ type: SELECTED_FAQ, payload: value });
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};
